/**
 * vion-icon v1.0.1
 * (c) 2023 yangling
 * @license MIT
 */

import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createElementVNode } from 'vue';

var Download = defineComponent({
  name: "Download",
  props: {
    color: String,
    size: String
  },
  emits: ["click"],
  setup: function setup(props, ctx) {
    var iconStyle = computed(function () {
      return {
        display: "inline-block",
        fontSize: props.size,
        color: props.color,
        width: "1em",
        height: "1em",
        lineHeight: "1em"
      };
    });
    var click = function click(e) {
      return ctx.emit("click", e);
    };
    return {
      iconStyle: iconStyle,
      click: click
    };
  }
});
Download.install = function (app) {
  app.component(Download.name, Download);
};

var _hoisted_1 = /* @__PURE__ */createElementVNode("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [/* @__PURE__ */createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M26.0154 6.10315H22.0154V10.1031V26.1031V27.3224L21.2078 26.5147L17.6722 22.9792L14.8438 20.1508L12.0154 22.9792L14.8438 25.8076L21.2078 32.1716L24.0362 35L26.8646 32.1716L33.2286 25.8076L36.057 22.9792L33.2286 20.1508L30.4002 22.9792L26.8646 26.5147L26.0154 27.364V26.1031V10.1031V6.10315ZM8 38H11.4286H36.5714H40V38.5715V41.4286V42H36.5714H11.4286H8V41.4286V38.5715V38Z",
  fill: "currentColor"
})], -1);
var _hoisted_2 = [_hoisted_1];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: "v-icon",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.click && _ctx.click.apply(_ctx, arguments);
    }),
    style: normalizeStyle(_ctx.iconStyle)
  }, _hoisted_2, 4);
}

Download.render = render;

export { Download as default };
